import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseResponse } from '../shared';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs';
import camelcaseKeys from 'camelcase-keys';

interface GuardianInfoResponse extends BaseResponse {
	data: {
		id: string;
		first_name: string;
		last_name: string;
		surveys_id?: number;
		subscription_details: {
			expire_date: string;
			expire_date_counter: string;
			active_subscription: string;
			subscription_type: string;
			email: string;
			extension_information: {
				extension_available: string;
				expire_note: string;
				renew_button: string;
				extension_note: string;
				extend_button: string;
			};
			subscription_status: string;
			subscription_status_note: string;
			subscription_name: string;
			subscription_expires: string;
			subscription_price: number;
			subscription_price_currency_sign: string;
			next_subscription_date: string;
		};
		expire_date: string;
		expire_date_counter: string;
		active_subscription: string;
		subscription_type: string;
		email: string;
		extension_information: {
			expire_note: string;
			renew_button: string;
			extension_note: string;
			extend_button: string;
		};
		subscription_status: string;
		subscription_status_note: string;
		subscription_name: string;
		subscription_expires: string;
		subscription_top_text: string;
		subscription_pros: string[];
	}[];
}

@Injectable({
	providedIn: 'root',
})
export class GuardianService {
	constructor(private http: HttpClient) {}

	getGuardianInfo(guardiansId: string | undefined) {
		return this.http
			.get<GuardianInfoResponse>(`${environment.apiUrl}/guardians/${guardiansId}`)
			.pipe(map((res) => camelcaseKeys(res, { deep: true })));
	}

	extendMembership(guardiansId: string) {
		return this.http
			.post<BaseResponse>(`${environment.apiUrl}/guardians/${guardiansId}/extend-subscription`, {})
			.pipe(map((res) => camelcaseKeys(res, { deep: true })));
	}

	cancelMembership() {
		return this.http
			.put<BaseResponse>(`${environment.apiUrl}/guardians/cancel-subscription`, {})
			.pipe(map((res) => camelcaseKeys(res, { deep: true })));
	}
}
